import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Vue from 'vue';
import ajwt from '@/utils/axios-jwt';
import moment from 'moment';
import axios from 'axios';
import VueAxios from 'vue-axios';
import FullCalendar from 'vue-full-calendar';
import Loading from 'vue-loading-overlay';
import App from './App.vue';
import router from './router';
import store from './store';
// import './registerServiceWorker';

const rax = require('retry-axios');

const instance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_BASE_URI,
});
instance.defaults.raxConfig = {
  instance,
};

ajwt.attach(instance);
rax.attach(instance);

Vue.use(VueAxios, axios, FullCalendar, Loading);
Vue.use(require('vue-moment'));
Vue.config.productionTip = false;
Vue.prototype.request = instance;

window.moment = moment;
window.request = instance;

Date.prototype.toISOStringZoned = function () {
  var tzo = -this.getTimezoneOffset(),
    dif = tzo >= 0 ? '+' : '-',
    pad = function (num) {
      var norm = Math.floor(Math.abs(num));
      return (norm < 10 ? '0' : '') + norm;
    };
  return (
    this.getFullYear() +
    '-' +
    pad(this.getMonth() + 1) +
    '-' +
    pad(this.getDate()) +
    'T' +
    pad(this.getHours()) +
    ':' +
    pad(this.getMinutes()) +
    ':' +
    pad(this.getSeconds()) +
    dif +
    pad(tzo / 60) +
    ':' +
    pad(tzo % 60)
  );
};

Date.prototype.getWeek = function () {
  var onejan = new Date(this.getFullYear(), 0, 1);
  return Math.ceil(((this - onejan) / 86400000 + onejan.getDay() + 1) / 7);
};

Promise.prototype.finally = Promise.prototype.finally || {
  finally (fn) {
    const onFinally = value => Promise.resolve(fn()).then(() => value);
    return this.then(
      result => onFinally(result),
      reason => onFinally(Promise.reject(reason))
    );
  }
}.finally;


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = `${to.meta.title} | SALL Activity`;
  } else {
    document.title = 'SALL Activity';
  }
  next();
});
